import { Nav, Tab } from "react-bootstrap";
import { ILicenceTransferDetails } from "../../../api/ILicenceTransfer";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  licenceTransferDetails: ILicenceTransferDetails;
  licenceProfile: ILicenceProfile;
}

interface FurtherInformationProps {
  licenceTransferDetails: ILicenceTransferDetails;
  licenceProfile: ILicenceProfile;
}

const SubTabs = ({
  className,
  activeKey,
  licenceTransferDetails,
  licenceProfile,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid
            regardingObjectId={licenceTransferDetails.licencetransferid}
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const FurtherInformation = ({
  licenceTransferDetails,
  licenceProfile,
}: FurtherInformationProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="documents"
      licenceTransferDetails={licenceTransferDetails}
      licenceProfile={licenceProfile}
    />
  );
  return <EpaCard title={"Further Information"} content={bodyElements} />;
};

export default FurtherInformation;
